import { createCRUD } from 'redux/base-api';

export default createCRUD('checklists');
